import { useState } from 'react';
import { Select } from 'antd';

import { optionSearchFilter } from '../Input';
import { countryOptions } from '../../utils/countries';
import { DEFAULT_COUNTRY, normalizeCountry } from '../../utils/elementFormat/phone';

/**
 * The card-definition sub-editor for a `phone` element's one option
 * (docs/plans/data-types.md decision 6):
 *
 *   country   the region a NATIONAL number ("202 555 0123") is read against,
 *             and the region a stored number is read BACK in — national at
 *             home, international abroad. Default US.
 *
 * It is the only setting a phone element has, and it is not cosmetic: the
 * same ten digits are a real number in one country and not a number at all in
 * another, so this is what decides whether the form accepts what someone
 * types. A number written in full international form ('+44 20 7183 8750')
 * ignores it entirely.
 *
 * The list is short on purpose and the search box takes any real two-letter
 * code (utils/countries explains why there is no 250-row roster here).
 *
 * Writes go through the form's path-based onChange (`elements[i].options.x`)
 * so this editor holds no state of its own beyond what the user has typed
 * into the search box.
 */
export default function PhoneOptions({ index, element, onChange, basePath = null }) {
	const options = element?.options || {};
	const prefix = `${basePath || `elements[${index}]`}.options`;
	const [search, setSearch] = useState('');
	const value = normalizeCountry(options.country) || DEFAULT_COUNTRY;

	return (
		<div className='phone-options'>
			<div className='micro-label card-def-element__section'>Phone</div>
			<div className='mb-2'>
				<label className='d-block' htmlFor={`${prefix}.country`}>Country</label>
				<Select
					id={`${prefix}.country`}
					size='large'
					className='w-100'
					value={value}
					onChange={next => onChange(`${prefix}.country`, next)}
					onSearch={setSearch}
					options={countryOptions({ value, search })}
					showSearch
					filterOption={optionSearchFilter}
					aria-label='Country'
				/>
				<div className='form-panel__hint'>
					The country a number without a country code belongs to. Numbers from
					elsewhere still save — they show with their country code.
				</div>
			</div>
		</div>
	);
}
